import { useState } from "react";
import labels from "../../utils/labels";
import TabButton from "../UI/tab/TabButton";
import ColouredRoundWrapper from "../UI/wrappers/ColouredRoundWrapper";
import drawerStyles from "../../styles/drawer.module.css";
import EmployeePreferencesTab from "./preferencesTab/EmployeePreferencesTab";
import EmployeeSettingsTab from "./EmployeeSettingsTab";

type EmployeeDrawerTabsType = "EMPLOYEE" | "PREFERENCES";
type EmployeeDrawerTabObject = { title: string; type: EmployeeDrawerTabsType };

const EmployeeDrawerContent = ({
  onEmployeeUnsavedEdit,
  onDeleteWorkTimeRequest,
}: {
  onEmployeeUnsavedEdit: (hasChanges: boolean) => void;
  onDeleteWorkTimeRequest: () => void;
}) => {
  const [selected, setSelected] = useState<EmployeeDrawerTabsType>("EMPLOYEE");

  const tabBarValues: EmployeeDrawerTabObject[] = [
    { title: labels.employeeSettings, type: "EMPLOYEE" },
    { title: labels.citizenPreferences, type: "PREFERENCES" },
  ];

  return (
    <div className={drawerStyles.drawerContent}>
      <ColouredRoundWrapper bgColor="var(--col-surface-secondary)" width="100%">
        {tabBarValues.map((tab, index) => (
          <TabButton
            key={index}
            fullWidth
            tabTitle={
              tab.type === "EMPLOYEE"
                ? labels.employeeSettings
                : labels.citizenPreferences
            }
            onClick={() => setSelected(tab.type)}
            selected={
              selected === "EMPLOYEE"
                ? labels.employeeSettings
                : labels.citizenPreferences
            }
          />
        ))}
      </ColouredRoundWrapper>

      {selected === "EMPLOYEE" && (
        <EmployeeSettingsTab
          onEmployeeUnsavedEdit={onEmployeeUnsavedEdit}
          onDeleteWorkTimeRequest={onDeleteWorkTimeRequest}
        />
      )}
      {selected === "PREFERENCES" && <EmployeePreferencesTab />}
    </div>
  );
};

export default EmployeeDrawerContent;
